export const messageTypes = {
    MESSAGE_REQUEST: 'Message Info is requesting',
    MESSAGE_VIEW_SUCCESS: 'Message Info view successfully',
    MESSAGE_VIEW_ERROR: 'Message info doesn view',
    MESSAGE_CLEAR: 'Message Info is cleared',
    MESSAGE_SHOW: 'Message - show',
};
